import { serialize, setEventEmitter } from "@src/components/DefuseSDK/utils"
import { useMixpanel } from "@src/providers/MixpanelProvider"
import bus, { TRACKED_EVENTS } from "@src/services/EventBus"
import { logger } from "@src/utils/logger"
import type { Dict } from "mixpanel-browser"
import { useCallback, useEffect } from "react"
import { useAnalyticsSuppressed } from "./useAnalyticsSuppressed"

export function useMixpanelBus() {
  const mixPanel = useMixpanel()
  const suppressed = useAnalyticsSuppressed()

  useEffect(() => {
    setEventEmitter(bus)
  }, [])

  const sendMixPanelEvent = useCallback(
    (eventName: string, payload: Dict) => {
      if (suppressed) return
      mixPanel?.track(eventName, JSON.parse(serialize(payload)))
    },
    [mixPanel, suppressed]
  )

  useEffect(() => {
    if (bus) {
      const listeners: Array<(payload: Dict) => void> = []

      for (const event of TRACKED_EVENTS) {
        const listener = (payload: Dict) => {
          try {
            sendMixPanelEvent(event, payload)
          } catch {
            // Analytics must never propagate exceptions back through EventEmitter
          }
        }
        listeners.push(listener)
        bus.on(event, listener)
      }

      return () => {
        if (bus) {
          for (let i = 0; i < TRACKED_EVENTS.length; i++) {
            bus.removeListener(TRACKED_EVENTS[i], listeners[i])
          }
        }
      }
    }

    logger.error("event bus is not defined")
    return
  }, [sendMixPanelEvent])

  return mixPanel
}
